<template>
	<div>
        <div class="block">
            <b-checkbox v-model="notification">
                Notification
            </b-checkbox>
            <b-checkbox v-model="comment">
                Comments
            </b-checkbox>
            <b-checkbox v-model="log">
                Logs
            </b-checkbox>
        </div>

        <div :class="{'b-table is-loading' : loading}">
			<div class="table-wrapper b-table">
				<table class="table">
					<tr>
						<th class="is-narrow">Date</th>
						<th>Type</th>
						<th>Creator</th>
						<th>Details</th>
					</tr>
					<tr v-for="(row, key) in allData">
						<td>{{ row.createdAt }}</td>
						<td>{{ row.subtype ? row.subtype : 'N/A' }}</td>
						<td>{{ row.createdBy ? row.createdBy.firstName : 'N/A' }}</td>
						<td>
							<b-button size="is-small" @click="openData(row)">
					         	DATA
					        </b-button>
						</td>
					</tr>
				</table>
			</div>
        </div>
	
		<b-modal :active.sync="modalData"
		has-modal-card
		trap-focus
		:destroy-on-hide="true"
		aria-role="dialog"
		aria-modal>
			<div class="modal-card" style="width: auto: min-width:300px;">
			    <section class="modal-card-body">
			        <vue-json-pretty
			        v-if="objectResult"
			        :path="'res'"
			        :data="objectResult">
			        </vue-json-pretty>
			        <p v-else>{{ dataResult }}</p>
			    </section>
			    <footer class="modal-card-foot">
			        <button class="button" type="button" @click="modalData = false">Close</button>
			    </footer>
		    </div>
		</b-modal>
	</div>
</template>
<script>
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { NotificationService } from "@/services/notification.service";
import { CommentService } from "@/services/comment.service";
import { LogService } from "@/services/log.service";
import VueJsonPretty from 'vue-json-pretty'
import moment from "moment";
export default {
	components: { VueJsonPretty },
	props: ['type', 'model', 'perPage'],
	data: () => ({
		notification: true,
		comment: false,
		log: false,
		modalData: false,
		objectResult: null,
		dataResult: null,
		notificationData: {},
		commentData: {},
		logData: {},
		loading: false,
	}),
	computed: {
		allData() {
			return {};
		},
		params() {
	        let data = {
	            includes: "createdBy",
	            per_page: this.perPage ? this.perPage : 20,
	        };
	        if (this.type) {
	            data.type  = this.type;
	            data.model = this.model.id;
	        }
	        return data;
	    },
	    allData() {
	    	let data = [];
	    	if (this.notificationData.length && this.notification) {
				Object.entries(this.notificationData).forEach((value, index) => {
					let date = moment(value[1].createdAt).format('MMMM DD YY hh:mm:ss');
					let sort = moment(value[1].createdAt).format('X');
					value[1].order = sort;
					value[1].createdAt = date;
					data.push(value[1])
				});
	    	}
	    	if (this.commentData.length && this.comment) {
				Object.entries(this.commentData).forEach((value, index) => {
					let date = moment(value[1].createdAt).format('MMMM DD YY hh:mm:ss');
					let sort = moment(value[1].createdAt).format('X');
					value[1].order = sort;
					value[1].createdAt = date;
					data.push(value[1])
				});
	    	}
	    	if (this.logData.length && this.log) {
				Object.entries(this.logData).forEach((value, index) => {
					let date = moment(value[1].createdAt).format('MMMM DD YY hh:mm:ss');
					let sort = moment(value[1].createdAt).format('X');
					value[1].order = sort;
					value[1].createdAt = date;
					data.push(value[1])
				});
	    	}
	    	return this.sortData(data);
	    }
	},
	watch: {
		model() {
			this.loading = true;
			this.getNotification();
			this.getComments();
			this.getLogs().then(() => {
				this.loading = false;
			});
		}
	},
	methods: {
		async getNotification() {
			await NotificationService.all(this.params).then(response => {
				this.notificationData =JsonDenormalizer.denormalize(response);
			});
		},
		async getComments() {
			await CommentService.all(this.params).then(response => {
				this.commentData = JsonDenormalizer.denormalize(response);
			});
		},
		async getLogs() {
			await LogService.all(this.params).then(response => {
				this.logData = JsonDenormalizer.denormalize(response);
			});
		},
	    openData(data) {
	    	this.objectResult = null;
	    	if (data.type.toLowerCase() == 'comments' || data.type.toLowerCase() == 'logs') {
	        	this.dataResult = data.content;
	    	}else{
	        	this.objectResult = data.data;
	    	}
	        this.$nextTick(() => {
	            this.modalData = true;
	        });
	    },
	    sortData(data) {
    	 	return data.sort((a, b)=> b.order - a.order)
    	},
	},
	mounted() {
		this.getNotification();
		this.getComments();
		this.getLogs();
	}
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/persons/notification.vue